import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, RouteProps } from 'react-router-dom'

import { TokenInterface } from '@store/actionSlices/token'
import type { ProjectIdentity, RootStateTypeExtra, User } from '@store/types'

import { SessionMap } from '@firebaseUtil/types'

import { hasToken } from '@adUtilities/token-helper'

export type ProtectedRouteProps = {
  redirectSessionPath: string
  authenticationPath: string
  session: SessionMap | undefined
  user: User
  projectIdentity: ProjectIdentity
  token: TokenInterface
} & RouteProps

function ProtectedRoutes({
  redirectSessionPath,
  authenticationPath,
  session,
  projectIdentity,
  token,
  ...routeProps
}: ProtectedRouteProps) {
  const [isAuthenticated, setIsAuthenticated] = React.useState(true)
  const [hasSession, setHasSession] = React.useState(false)

  React.useEffect(() => {
    if (!hasToken(token)) {
      setIsAuthenticated(false)
    }
  }, [token])

  React.useEffect(() => {
    if (session) {
      const { connected } = session
      if (
        connected &&
        projectIdentity.sessionId &&
        projectIdentity.sessionList.length > 0
      ) {
        setHasSession(true)
      }
    }
  }, [session, projectIdentity])

  if (!isAuthenticated) {
    return <Redirect to={{ pathname: authenticationPath }} />
  }

  if (!hasSession) {
    return <Route {...routeProps} />
  }

  return <Redirect to={{ pathname: redirectSessionPath }} />
}

export default connect(
  ({
    firestore: { session },
    projectIdentity,
    token,
    user,
  }: RootStateTypeExtra) => ({
    session,
    projectIdentity,
    token,
    user,
  })
)(ProtectedRoutes)
